<router-outlet></router-outlet>
<app-notifications-container></app-notifications-container>

<!-- @if (isAppError) {
  @if (isUserUnauthenticated) {
    <div class="error-overlay">
      <div class="error-card">
        <div class="error-icon-container">
          <div class="error-icon-circle auth">
            <svg class="error-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              ></path>
            </svg>
          </div>
        </div>

        <h1 class="error-title">Authentication Required</h1>
        <h2 class="error-subtitle">We were unable to authenticate you.</h2>
        <p class="error-message">
          If you were logged in earlier, your session may have expired. Please login to continue using the application.
        </p>

        <div class="auth-button-container">
          <app-auth-button></app-auth-button>
        </div>
      </div>
    </div>
  } @else {
    <div class="error-overlay">
      <div class="error-card">
        <div class="error-icon-container">
          <div class="error-icon-circle error">
            <svg class="error-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          </div>
        </div>

        <h1 class="error-title">Something Went Wrong</h1>
        <p class="error-message">
          We encountered an unexpected error. Please try refreshing the page or contact support if the problem persists.
        </p>

        <button onclick="window.location.reload()" class="refresh-button">
          <svg class="refresh-button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            ></path>
          </svg>
          Refresh Page
        </button>
      </div>
    </div>
  }
} -->
